export default __webpack_public_path__ + "static/media/documentCheck.a6bd262d.svg";